﻿const canTranslateAPIURL = "/api/translatelanguage/getTranslatedData";
const getCacheConfigAPIURL = "/api/translatelanguage/getConfig";

/*
    Init config:
    - Create a div with "can-translate" class. This will be the container for the languages dropdown. 

    Note:
    1. Post to api requires longer timeout duration - each retry takes avg of 1.5mins
    2. Add "ct-ignore" class to element with text to ignore translation
*/

/*
    Translated text cache retention:
    - Set each value to -1 to skip individual cache clean up
    - Total Cache clean up will include unused cache
    - Default browser allows max 5MB local storage per origin
*/
var daysToKeepTotalCache;
var daysToKeepUnusedCache;
var maxMBToKeepTotalCache;
var maxContentLenPerPost;

var originalEngText = {};
var serialID = 0;
var translatedCache = {};
var postRequestCount = 0;
var translateQueueArr = [];
const maxPostRequest = 4;

function initDropdown() {
    let container = document.getElementsByClassName("can-translate");
    let dropdownHtml = `
        <div class="can-translate-toggle" title="Translation" aria-label="Translation">
            <span class="can-translating">
                <span id="text">Translating</span>
                <span id="dot"></span>
                <span id="dot"></span>
                <span id="dot"></span>
            </span>
        </div>
        <ul class="can-translate-dropdown ct-dropdown-menu ct-pull-right can-translate-lang-sel" data-sel-lang="">
            <li><a class="ct-ignore click-utag" href="#" data-lang="eng">English</a></li>
            <li><a class="ct-ignore click-utag" href="#" data-lang="zh-Hans">中文</a></li>
            <li><a class="ct-ignore click-utag" href="#" data-lang="ja">日本語</a></li>
            <li><a class="ct-ignore click-utag" href="#" data-lang="ko">한국어</a></li>
            <li style="margin-top:10px;line-height:1.5em;font-size:12px;padding-left:15px;"><i>The site will be machine translated</i></li>
        </ul>
        `;
    /* exclude for now:
    <li><a class="ct-ignore" href="#" data-lang="th">ไทย</a></li>
    <li><a class="ct-ignore" href="#" data-lang="id">Bahasa Indonesia</a></li>
    <li><a class="ct-ignore" href="#" data-lang="es">Español</a></li>
    <li><a class="ct-ignore" href="#" data-lang="de">Deutsch</a></li>
    <li><a class="ct-ignore" href="#" data-lang="fr">Français</a></li>
    <li><a class="ct-ignore" href="#" data-lang="pt">Português</a></li>
    */
    if (container[0].childNodes.length > 0 ) { //empty child
        container[0].innerHTML += dropdownHtml;
    }

    // for mobile
    let listcontainer = document.querySelector(".icon-section .account-dropdown > ul");
    if (listcontainer) {
        let html = `
        <li>
            <div class="can-translate-mobile">
                <div class="can-translate-mobile-container">
                    <div class="can-translate-image">
                        <img src="/dist/img/omdia/translation.svg" alt="Translate" />
                    </div>
                    <div class="can-translate-mobile-text">Language</div>
                </div>
            </div>
        </li>
        `;
        listcontainer.innerHTML = html + listcontainer.innerHTML;
    }
    // end for mobile
}

function initLanguageSelectionModal() {
    let html = `
    <div class="lightbox-modal can-translate-modal can-translate-lang-modal">
        <div class="dismiss-button js-close-lightbox-modal btn-can-dismiss">
            <svg class="dismiss-button__icon">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/img/svg-sprite.svg#x"></use>
            </svg>
        </div>
        <div class="can-modal-header">
            <div class="can-modal-title">Select Language</div>
            <div class="can-modal-subtitle">The site will be machine translated</div>
        </div>
        <div class="can-modal-body can-translate-lang-sel">
            <li><a class="m-lang ct-ignore" href="#" data-lang="eng">English</a></li>
            <li><a class="m-lang ct-ignore" href="#" data-lang="zh-Hans">中文</a></li>
            <li><a class="m-lang ct-ignore" href="#" data-lang="ja">日本語</a></li>
            <li><a class="m-lang ct-ignore" href="#" data-lang="ko">한국어</a></li>
        </div>
    </div>
    `;

    let container = document.querySelector('.can-translate');
    if (container) {
        container.insertAdjacentHTML('afterend', html);
    }

    let elem = document.querySelector(".can-translate-mobile");
    elem.addEventListener("click", function () {
        let langModalElem = document.querySelector(".can-translate-lang-modal");
        langModalElem.style.display = "block";
        langModalElem.insertAdjacentHTML("afterend", '<div class="lightbox-modal__backdrop"></div>');
    })
}

function addDropdownToggle() {
    let toggleBtn = document.querySelector(".can-translate");
    let dropdown = document.querySelector(".can-translate-dropdown");

    // toggleBtn.addEventListener("click", function () {
    //     dropdown.classList.toggle("ct-show");

    //     if (dropdown.classList.contains("ct-show")) {
    //         document.body.addEventListener("click", addDropdownHideEvent);
    //     } else {
    //         document.body.removeEventListener("click", addDropdownHideEvent);
    //     }
    // });

    if (!toggleBtn || !dropdown) return;

    function openDropdown() {
        dropdown.classList.add("ct-show");
        document.body.addEventListener("click", outsideClickHandler);
    }

    function closeDropdown() {
        dropdown.classList.remove("ct-show");
        document.body.removeEventListener("click", outsideClickHandler);
    }

    function toggleDropdown(e) {
        e.stopPropagation();
        dropdown.classList.contains("ct-show") ? closeDropdown() : openDropdown();
    }

    function outsideClickHandler(e) {
        if (!toggleBtn.contains(e.target) && !dropdown.contains(e.target)) {
            closeDropdown();
        }
    }

    // CLICK
    toggleBtn.addEventListener("click", toggleDropdown);

    // HOVER
    toggleBtn.addEventListener("mouseenter", openDropdown);
    dropdown.addEventListener("mouseenter", openDropdown);

    toggleBtn.addEventListener("mouseleave", () => {
        setTimeout(() => {
            if (!dropdown.matches(":hover")) {
                closeDropdown();
            }
        }, 100);
    });

    dropdown.addEventListener("mouseleave", closeDropdown);
}

function addDropdownHideEvent(e) {
    // Close the dropdown if the user clicks outside of it
    if (!e.target.matches('.can-translate')) {
        let dropdown = document.querySelector(".can-translate-dropdown");
        dropdown.classList.remove("ct-show");
        document.body.removeEventListener("click", addDropdownHideEvent);
    }
}

function getPageText(subsequentLangSwitch) {
    let textObj = {};
    let htmlCollection = document.body.getElementsByTagName("*");
    const skipTranslateTags = ["SCRIPT", "NOSCRIPT", "STYLE"];

    if (!subsequentLangSwitch) {
        Array.from(htmlCollection).forEach(function (elem) {
            if (elem.childNodes.length) {
                if (!elem.classList.contains("ct-ignore")) {
                    // handle title value
                    if (!elem.hasAttribute("data-ct-title-pending")) {
                        let elemTag = elem.tagName;
                        if (!skipTranslateTags.includes(elemTag)) {
                            if (elem.hasAttribute("title") && elem.title) { //elem.title is not undefined
                                let text = elem.title.replace(/\s+/g, " ").trim();
                                if (text.length > 1) { //skip single character
                                    if (!elem.hasAttribute("data-ct-title-tran")) {
                                        let nodeID = serialID + "-title";
                                        elem.setAttribute("data-ct-title-id", serialID);
                                        elem.setAttribute("data-ct-title-pending", "1");
                                        textObj[nodeID] = sanitizeText(text); // only store new untranslated title
                                        originalEngText[nodeID] = text;
                                        serialID++;
                                    }
                                }
                            }
                        }
                    }
                    // handle text value
                    if (!elem.hasAttribute("data-ct-pending")) {
                        elem.childNodes.forEach(function (currentValue, currentIndex, listObj) {
                            if (currentValue.nodeType === 3) { // text node
                                let parentNode = currentValue.parentNode;
                                let parentTag = parentNode.tagName;
                                if (!skipTranslateTags.includes(parentTag)) {
                                    let text = currentValue.nodeValue.replace(/\s+/g, " ").trim();
                                    if (text.length > 1) { //skip single character
                                        let nodeID = serialID + "-" + currentIndex;
                                        if (parentNode.hasAttribute("data-ct-id")) { //parent node already tagged with a id from earlier node with text
                                            if (!parentNode.hasAttribute("data-ct-tran")) {
                                                parentNode.setAttribute("data-ct-pending", "1");
                                                let parentNodeID = parentNode.getAttribute("data-ct-id");
                                                nodeID = parentNodeID + "-" + currentIndex;
                                                textObj[nodeID] = sanitizeText(text); // only store new untranslated text
                                                originalEngText[nodeID] = text;
                                            }
                                        } else {
                                            parentNode.setAttribute("data-ct-id", serialID);
                                            parentNode.setAttribute("data-ct-pending", "1");
                                            textObj[nodeID] = sanitizeText(text); // only store new untranslated text
                                            originalEngText[nodeID] = text;
                                            serialID++;
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
            }
        });
    } else {
        textObj = { ...originalEngText };
    }

    return textObj;
}

function sanitizeText(text) {
    text = text.replace(/&#xa0;/g, ' ');
    return text;
}

function initTranslationCache() {

    translatedCache = JSON.parse(window.localStorage.getItem("ct-translated")) || {};
}

function updateCacheLastUsedTime(lang, text) {
    //need to update local storage
    translatedCache[lang][text][1] = Date.now();
}

function maintainTranslationCache() {
    cleanUpTotalCache();
    cleanUpUnusedCache();
    cleanUpCacheSizeUsage()
}

function cleanUpTotalCache() {
    if (!daysToKeepTotalCache || daysToKeepTotalCache === -1) {
        return;
    }
    const cache = JSON.parse(window.localStorage.getItem("ct-params"));
    if (cache) {
        const initialCacheDate = cache["init-date"];
        if (Date.now() - initialCacheDate > 1000 * 60 * 60 * 24 * daysToKeepTotalCache) {
            delete window.localStorage["ct-params"];
            delete window.localStorage["ct-translated"];
        }
    }
}

function cleanUpUnusedCache() {
    if (!daysToKeepUnusedCache || daysToKeepUnusedCache === -1) {
        return;
    }
    const cache = JSON.parse(window.localStorage.getItem("ct-translated")) || {};
    if (Object.keys(cache).length) {
        for (const lang in cache) {
            for (const key in cache[lang]) {
                let lastUsed = cache[lang][key][1];
                if (Date.now() - lastUsed > 1000 * 60 * 60 * 24 * daysToKeepUnusedCache) {
                    delete cache[lang][key];
                }
            }
            updateLocalStorage("ct-translated", lang, cache[lang]);
        }
    }
}

function cleanUpCacheSizeUsage() {
    if (!maxMBToKeepTotalCache || maxMBToKeepTotalCache === -1) {
        return;
    }
    //to clean up translated text cache while retaining translation config
    const cache = JSON.parse(window.localStorage.getItem("ct-translated")) || {}; //only check against this key since it contains the most data
    if (Object.keys(cache).length) {
        let cacheSizeMB = (localStorage["ct-translated"].length + "ct-translated".length) * 2 / 1024 / 1024; //to include length of key; len * 2 becos char in js stores as UTF-16 of 2 bytes each
        if (cacheSizeMB >= maxMBToKeepTotalCache) {
            delete window.localStorage["ct-translated"]; //delete all cache is more practical than clearing partial cache to avoid data error
        }
    }
}

function updateNodeToTranslatedText(nodeIndex, translatedText) {
    let [index, subIndex] = nodeIndex.split("-");
    let isTitle = subIndex === "title" ? "title-" : "";
    let parentNode = document.querySelector("[data-ct-" + isTitle + "id='" + index + "']");
    if (parentNode) {
        parentNode.setAttribute("data-ct-" + isTitle + "tran", "1");
        parentNode.removeAttribute("data-ct-" + isTitle + "pending");

        if (isTitle) {
            parentNode.title = translatedText;
        } else {
            let targetNode = parentNode.childNodes[subIndex];
            if (targetNode) {
                targetNode.nodeValue = translatedText;
            }
        }
    } else {
        delete originalEngText[nodeIndex]; //dynamic node no longer exist
    }

}

function translateText(text, lang, retry = false) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        try {
            if (this.readyState == 4) {
                if (this.status == 200) {
                    var result = JSON.parse(this.responseText);
                    postRequestCount--;

                    if (result["status"] !== "S") {
                        if (document.querySelector(".can-translate-dropdown ").getAttribute("data-sel-lang") !== "eng") {
                            let alertModal = document.querySelector('.can-translate-alert-modal');
                            if (alertModal) {
                                alertModal.style.display = 'block';
                            }
                        }
                    }
                    else {
                        let json = result["response"];

                        for (const key in json) {
                            if (!translatedCache[lang]) {
                                translatedCache[lang] = {};
                            }
                            translatedCache[lang][text[key]] = [json[key], Date.now()];

                            if (document.querySelector(".can-translate-dropdown ").getAttribute("data-sel-lang") === "eng") {
                                //continue translate but stop translated text replacement when lang switched back to eng while previous translation just got its curl response back
                                if (postRequestCount !== maxPostRequest && translateQueueArr.length) {
                                    let [set, selectedLang] = translateQueueArr.shift();
                                    translateText(set, selectedLang);
                                }
                                return;
                            }
                            updateNodeToTranslatedText(key, json[key]);
                        }
                        if (Object.keys(translatedCache[lang]).length) {
                            updateLocalStorage("ct-translated", lang, translatedCache[lang]);
                        }
                    }

                    if (translateQueueArr.length) {
                        let [set, selectedLang] = translateQueueArr.shift();
                        translateText(set, selectedLang);
                    } else {
                        toggleTranslatingProgress(postRequestCount);
                    }
                }
                else if (this.status == 504) {
                    throw ("Post request timeout.");
                }
                else {
                    throw ("Request failed with status: " + this.status);
                }
            }

        } catch (e) {
            let msg = retry ? "(Retried)" : "";
            console.log("[translateText" + msg + "] Caught exception : " + e);
            postRequestCount--;
            if (!retry) {
                console.log("retrying translate now...");
                translateText(text, lang, true); //retry once
            } else {
                if (translateQueueArr.length) {
                    let [set, selectedLang] = translateQueueArr.shift();
                    translateText(set, selectedLang);
                } else {
                    toggleTranslatingProgress(postRequestCount);
                }
            }
        }
    };

    xhttp.ontimeout = (e) => {
        console.log("[translateText] ajax timeout.");
        postRequestCount--;
        toggleTranslatingProgress(postRequestCount);
    };

    var sendString = "to=" + lang + "&text=" + encodeURIComponent(JSON.stringify(text));

    xhttp.open("POST", canTranslateAPIURL, true);
    xhttp.timeout = 180000; //3mins in milliseconds
    xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhttp.send(sendString);

    postRequestCount++;
    toggleTranslatingProgress(postRequestCount);
}

function toggleTranslatingProgress(count = null) {
    let elem = document.querySelector(".can-translating");
    let show = elem.classList.contains("slide-in");
    let currLang = document.querySelector(".can-translate-dropdown ").getAttribute("data-sel-lang");
    if (currLang === "eng") {
        if (show) {
            elem.classList.remove("slide-in");
            elem.classList.add("slide-out");
        }
        return;
    }

    if (count > 0) {
        if (!show) {
            elem.classList.remove("slide-out");
            elem.classList.add("slide-in");
        }
    } else {
        if (show) {
            elem.classList.remove("slide-in");
            elem.classList.add("slide-out");
        }
    }
}

function splitJSON(jsonText) //split to smaller parts based on content length - lower content length of <= 1000 will hit gpt rate limit more frequently (shared among all users)
{
    let setOfWordArr = [];
    let wordArr = {};

    for (const key in jsonText) {
        wordArr[key] = jsonText[key];
        if (JSON.stringify(wordArr).length >= maxContentLenPerPost) {
            setOfWordArr.push(wordArr);
            wordArr = {};
        }
    }
    if (Object.keys(wordArr).length) {
        setOfWordArr.push(wordArr);
    }
    return setOfWordArr;
}

function initDOMObserver() {
    const targetNode = document.querySelector("body");
    const config = { childList: true, subtree: true, characterData: true };

    const callback = (mutationList, observer) => {
        setTimeout(() => {
            let changes = false;
            let selectedLang = document.querySelector(".can-translate-dropdown").getAttribute("data-sel-lang");
            for (const mutation of mutationList) {
                if (mutation.type === "childList" || mutation.type === "characterData") {
                    
                    if (selectedLang && selectedLang !== "eng") {
                        changes = true;
                        captureElementTextChange(mutation, mutation.type);
                    }
                }
            }
            if (changes && selectedLang && selectedLang !== "eng") {
                getTranslation(selectedLang);
            } 
        }, 2000); // set a delay to capture more dom changes rather than each individual instance 

    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

function captureElementTextChange(mutation, type) {
    //when previous text value has been translated and on click dynamically changed the text value so need to re-translate
    if (type === "childList") {
        if (mutation.addedNodes.length && mutation.addedNodes[0].nodeType === 3) {
            let elem = mutation.target;
            if (elem.hasAttribute("data-ct-tran")) {
                let currID = elem.getAttribute("data-ct-id");

                if (!hasExistsInCache(elem.textContent)) {
                    // remove traces of translated text for re-translation
                    delete (originalEngText[currID]);
                    elem.removeAttribute("data-ct-tran");

                }
            }
        }
    }
    else {
        let parentElem = mutation.target.parentNode
        if (parentElem && parentElem.hasAttribute("data-ct-tran")) {
            let currID = parentElem.getAttribute("data-ct-id");

            if (!hasExistsInCache(mutation.target.data)) {
                // remove traces of translated text for re-translation
                delete (originalEngText[currID]);
                parentElem.removeAttribute("data-ct-tran");

            }
        }
    }
}

function hasExistsInCache(text) {
    let lang = document.querySelector(".can-translate-dropdown").getAttribute("data-sel-lang");
    let data = translatedCache[lang];

    for (const i in data) {
        if (data[i].includes(text)) {
            return true;
        }
    }
    return false;
}

function deleteLocalStorageKey(mainKey, key, subKey = null) {
    let obj = JSON.parse(window.localStorage.getItem(mainKey));
    if (obj) {
        if (!subKey) {
            delete obj[key];
        } else {
            delete obj[key][subKey];
        }
        window.localStorage.setItem(mainKey, JSON.stringify(obj));
    }
}

function updateLocalStorage(mainKey, key, value) {
    let obj = JSON.parse(window.localStorage.getItem(mainKey)) || {};
    obj[key] = value;
    window.localStorage.setItem(mainKey, JSON.stringify(obj));
}

function initTranslationLanguage() {
    let cache = JSON.parse(window.localStorage.getItem("ct-translation"));

    if (cache) {
        let lang = cache["lang"];

        if (lang) {
            document.querySelector(".can-translate-dropdown").setAttribute("data-sel-lang", lang);
        }
    }
}

function translateTextWithCache(jsonText, selectedLang) {
    if (Object.keys(translatedCache).length) {
        for (const key in jsonText) {
            let langCache = translatedCache[selectedLang];
            if (langCache) {
                let found = langCache[jsonText[key]];
                if (found) {
                    updateNodeToTranslatedText(key, found[0]);
                    updateCacheLastUsedTime(selectedLang, jsonText[key]);

                    delete jsonText[key];
                }
            }
        }
        updateLocalStorage("ct-translated", selectedLang, translatedCache[selectedLang]);
    }
    return jsonText;
}


function getTranslation(selectedLang, subsequentLangSwitch = false) {
    checkInitTranslationDate();

    let textToTranslate = getPageText(subsequentLangSwitch);
    textToTranslate = translateTextWithCache(textToTranslate, selectedLang);

    if (Object.keys(textToTranslate).length !== 0) {
        let sets = splitJSON(textToTranslate);

        for (const set of sets) {
            if (translateQueueArr.length || postRequestCount === maxPostRequest) {
                translateQueueArr.push([set, selectedLang]);
            } else {
                translateText(set, selectedLang);
            }
        }
    }
}

function checkInitTranslationDate() {
    const key = JSON.parse(window.localStorage.getItem("ct-params"));
    if (!key) {
        updateLocalStorage("ct-params", "init-date", Date.now());
    }
}

function updateLangSelectedCache(lang) {
    var languageData = {'event_name':'translation_language_cnt','selected_language':lang};
    analyticsEvent( $.extend(analytics_data, languageData) );

    if (lang != 'eng'){
        updateLocalStorage("ct-translation", "lang", lang)
    }
}

function removeLangSelectedCache() {
    delete window.localStorage["ct-translation"];
}

function initConfig() {
    return new Promise((resolve, reject) => {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            try {
                if (this.readyState == 4) {
                    if (this.status == 200) {
                        var result = JSON.parse(this.responseText);

                        if (result["status"] === "S") {
                            let json = result["response"];
                            for (const key in json) {
                                if (key === "daysToKeepTotalCache") {
                                    daysToKeepTotalCache = json[key];
                                } else if (key === "daysToKeepUnusedCache") {
                                    daysToKeepUnusedCache = json[key];
                                } else if (key === "maxMBToKeepTotalCache") {
                                    maxMBToKeepTotalCache = json[key];
                                } else if (key === "maxContentLenPerPost") {
                                    maxContentLenPerPost = json[key];
                                }
                            }
                        }
                        else {
                            let msg = result["response"] || this.responseText;
                            reject(msg);
                        }
                        resolve();

                    }
                    else if (this.status == 504) {
                        reject("[initConfig] Post request timeout.");
                    }
                    else {
                        reject("[initConfig] Request failed with status: " + this.status);
                    }
                }

            } catch (e) {
                reject("[initConfig] Caught exception on get cache config - " + e)
            }
        };

        xhttp.open("GET", getCacheConfigAPIURL, true);
        xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhttp.send();
    });
}

function resetToOriginalContent() {
    //reset to original english text
    for (const key in originalEngText) {
        let [index, subIndex] = key.split("-");
        let isTitle = subIndex === "title" ? "title-" : "";

        let parentNode = document.querySelector("[data-ct-" + isTitle + "id='" + index + "']");
        if (parentNode) {
            if (isTitle) {
                parentNode.title = originalEngText[key];
            } else {
                let targetNode = parentNode.childNodes[subIndex];
                if (targetNode) {
                    targetNode.nodeValue = originalEngText[key];
                }
            }
        } else {
            delete originalEngText[key]; //dynamic node no longer exist
        }
    }
}

function addAlertModal() {
    let html = `
    <div class="lightbox-modal can-translate-modal can-translate-alert-modal">
        <div class="dismiss-button js-close-lightbox-modal btn-can-dismiss">
            <svg class="dismiss-button__icon">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/img/svg-sprite.svg#x"></use>
            </svg>
        </div>

        <div class="lightbox-modal__title ct-ignore">
            <svg class="lightbox-modal__title-icon ">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/img/svg-sprite.svg#alert"></use>
            </svg>
            Failed to translate some text content
        </div>
        <p class="ct-ignore">Please refresh page and try again later</p>
        <button class="button--filled btn--can js-close-lightbox-modal ct-ignore btn-can-dismiss">Okay</button>
    </div>`;

    let container = document.querySelector('.can-translate');
    if (container) {
        container.insertAdjacentHTML('afterend', html);
    }
}

function addModalDismiss() {
    let dismissBtn = document.querySelectorAll(".btn-can-dismiss");
    for (var i = 0; i < dismissBtn.length; i++) {
        dismissBtn[i].addEventListener('click', function () {
            let parent = this.closest(".can-translate-modal")
            if (parent) parent.style.display = "none"

            let backdrop = document.querySelector(".lightbox-modal__backdrop");
            if (backdrop) backdrop.remove();
        })
    }
}

function updateLanguageSelectionModal() {
    const lang = document.querySelector(".can-translate-dropdown").getAttribute("data-sel-lang") || 'eng';
    const previousLang = document.querySelector(".can-translate-dropdown").getAttribute("data-prev-lang")

    if (previousLang) {
        const pElem = document.querySelector('.m-lang[data-lang=' + previousLang + ']');
        if (pElem) {
            const pParent = pElem.closest('li');
            pParent.classList.remove('lang-selected');
        }
    }
    
    const elem = document.querySelector('.m-lang[data-lang=' + lang + ']');
    if (elem) {
        const parent = elem.closest('li');
        parent.classList.add('lang-selected');
    }
}

function main(retryCount = 0) {
    initConfig()
        .then(() => {
            initDropdown();
            initLanguageSelectionModal();
            addAlertModal();
            addModalDismiss();
            addDropdownToggle();
            maintainTranslationCache();
            initTranslationCache();
            initTranslationLanguage();
            updateLanguageSelectionModal();
            initDOMObserver();

            let langOption = document.querySelectorAll(".can-translate-lang-sel li");
            for (var i = 0; i < langOption.length; i++) {
                langOption[i].addEventListener('click', function (e) {
                    let prevLang = document.querySelector(".can-translate-dropdown").getAttribute("data-sel-lang");
                    let selectedLang = e.currentTarget.querySelector("a").dataset.lang;
                    if (prevLang === selectedLang) {
                        return;
                    }

                    if (selectedLang === "eng") {
                        removeLangSelectedCache();
                        updateLangSelectedCache(selectedLang);
                    } else {
                        updateLangSelectedCache(selectedLang);
                        location.reload(); // translate will be faster since every post requests are staggered
                        return;
                    }

                    document.querySelector(".can-translate-dropdown").setAttribute("data-prev-lang", prevLang);
                    document.querySelector(".can-translate-dropdown").setAttribute("data-sel-lang", selectedLang);

                    document.querySelector(".can-translate-lang-modal").style.display = "none";
                    let backdrop = document.querySelector(".lightbox-modal__backdrop");
                    if (backdrop) backdrop.remove();
                    updateLanguageSelectionModal();

                    if (selectedLang !== "eng") {
                        let subsequentLangSwitch = false;
                        if (prevLang && Object.keys(originalEngText).length !== 0) { //originalEngText can be empty when nagivating between web pages
                            subsequentLangSwitch = true;
                        }
                        getTranslation(selectedLang, subsequentLangSwitch);

                    } else {
                        toggleTranslatingProgress();
                        resetToOriginalContent();
                    }
                });
            }

        })
        .catch((error) => {
            if (typeof error === "string" && error.includes("initConfig") && retryCount <= 2) {
                console.log("retrying for initConfig...")
                main(retryCount + 1);
            } else {
                console.error("Caught exception: " + error);
            }
        });
}


document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementsByClassName("can-translate").length == 0) {
        return;
    }
    main();
});